<script type="ts">
import 'intl-tel-input/build/css/intlTelInput.css'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'
import { fr } from "intl-tel-input/i18n"
import {defineComponent} from "vue"

export default defineComponent({
  name: "TelInput",
  props: {
    modelValue: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      phoneInput: null,
    }
  },
  watch: {
    modelValue() {
      this.phoneInput.setNumber(this.modelValue)
    },
  },
  mounted() {
    this.phoneInput = intlTelInput(this.$refs.input, {
      initialCountry: 'BE',
      dropdownContainer: this.$refs.dropdown_container,
      i18n: fr,
      separateDialCode: true,
      strictMode: true,
      autoPlaceholder: 'default',
    })
    this.$refs.input.addEventListener('countrychange', () => {
      setTimeout(() => {
        this.phoneInput._closeDropdown()
      }, 20)
    })
    if(this.modelValue !== undefined) {
      if(this.modelValue.startsWith("+")) {
        this.phoneInput.setNumber(this.modelValue)
      }else{
        this.$refs.input.value = this.modelValue
      }
    }
  },
  methods: {
    emitValue() {
      this.$emit('update:modelValue', this.phoneInput.getNumber())
    },
    closeDropdown() {
      document.body.click()
    }
  },
  emits: ['update:modelValue'],
})
</script>

<template>
  <div>
    <input @input="emitValue" ref="input" :class="'p-inputtext input' + (invalid ? ' invalid': '')" type="tel" :required="required">
    <div ref="dropdown_container" @click="closeDropdown" class="dropdown_container"></div>
  </div>
</template>

<style scoped lang="scss">
div:deep(){
  .iti{
    width: 100%;
  }
  input{
    width: 100%;
  }
  .invalid{
    border-color: var(--p-inputtext-invalid-border-color);
  }
}
.dropdown_container:deep(){
  .iti__search-input{
    font-family: inherit;
    font-feature-settings: inherit;
    font-size: 1rem;
    color: var(--p-inputtext-color);
    background: var(--p-inputtext-background);
    padding: var(--p-inputtext-padding-y) var(--p-inputtext-padding-x);
    border: 1px solid var(--p-inputtext-border-color);
    transition: background var(--p-inputtext-transition-duration), color var(--p-inputtext-transition-duration), border-color var(--p-inputtext-transition-duration), outline-color var(--p-inputtext-transition-duration), box-shadow var(--p-inputtext-transition-duration);
    appearance: none;
    border-radius: var(--p-inputtext-border-radius);
    outline-color: transparent;
    box-shadow: var(--p-inputtext-shadow);
    &:enabled:hover{
      border-color: var(--p-inputtext-hover-border-color);
    }
    &:enabled:focus{
      border-color: var(--p-inputtext-focus-border-color);
      box-shadow: var(--p-inputtext-focus-ring-shadow);
      outline: var(--p-inputtext-focus-ring-width) var(--p-inputtext-focus-ring-style) var(--p-inputtext-focus-ring-color);
      outline-offset: var(--p-inputtext-focus-ring-offset);
    }
  }
  .iti__a11y-text{
    display: none;
  }
  .iti__country-list{
    margin: 0;
    list-style-type: none;
    padding: var(--p-select-list-padding);
    gap: var(--p-select-list-gap);
    display: flex;
    flex-direction: column;
    background: transparent;
    color: var(--p-select-overlay-color);
    border: 0;
    border-radius: var(--p-select-overlay-border-radius);
    margin: 0 -0.7rem;
    margin-top: 0.5rem;
    .iti__country{
      cursor: pointer;
      font-weight: normal;
      display: flex;
      align-items: center;
      padding: var(--p-select-option-padding);
      border: 0 none;
      color: var(--p-select-option-color);
      background: transparent;
      transition: background var(--p-select-transition-duration), color var(--p-select-transition-duration), border-color var(--p-select-transition-duration), box-shadow var(--p-select-transition-duration), outline-color var(--p-select-transition-duration);
      border-radius: var(--p-select-option-border-radius);
      &:hover{
        background: var(--p-select-option-focus-background);
        color: var(--p-select-option-focus-color);
      }
    }
  }
  .iti__dropdown-content{
    border: 1px solid var(--p-select-overlay-border-color);
    border-radius: var(--p-select-overlay-border-radius);
    background: var(--p-select-overlay-background);
    padding: var(--p-select-option-padding);
    padding-bottom: 0;
  }
}
</style>